var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColorWavesContentpartnerSm = function SvgColorWavesContentpartnerSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 260,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#color-waves-contentpartner-sm_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M231.684 92.145C554.388 55.259 770.5 172.932 875 269.43L63.424 600.229-271 21.292C-31.666-60.456-91.02 129.031 231.684 92.145Z",
    fill: "url(#color-waves-contentpartner-sm_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M340.07 144.721c337.048 7.738 483.754 142.866 565.875 209.169L95 643.181-156-6.871C101.687-57.04 3.022 136.983 340.07 144.721Z",
    fill: "url(#color-waves-contentpartner-sm_svg__c)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "color-waves-contentpartner-sm_svg__g",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 460,
    height: 260
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#color-waves-contentpartner-sm_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M231.684 92.145C554.388 55.259 770.5 172.932 875 269.43L63.424 600.229-271 21.292C-31.666-60.456-91.02 129.031 231.684 92.145Z",
    fill: "url(#color-waves-contentpartner-sm_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M340.07 144.721c337.048 7.738 483.754 142.866 565.875 209.169L95 643.181-156-6.871C101.687-57.04 3.022 136.983 340.07 144.721Z",
    fill: "url(#color-waves-contentpartner-sm_svg__f)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "color-waves-contentpartner-sm_svg__b",
    x1: -92.632,
    y1: -145.336,
    x2: 835.752,
    y2: 290.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "#FF3D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D79C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "color-waves-contentpartner-sm_svg__c",
    x1: 40.278,
    y1: -145.271,
    x2: 932.754,
    y2: 434.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D79C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#D43341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#F19C33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "color-waves-contentpartner-sm_svg__e",
    x1: -92.632,
    y1: -145.336,
    x2: 835.752,
    y2: 290.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "#FF3D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#3D79C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "color-waves-contentpartner-sm_svg__f",
    x1: 40.278,
    y1: -145.271,
    x2: 932.754,
    y2: 434.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF9505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#FF0015"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#503DC2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "color-waves-contentpartner-sm_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h460v260H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "color-waves-contentpartner-sm_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h460v260H0z"
  })))));
};
export default SvgColorWavesContentpartnerSm;